import { Injectable } from "@angular/core";
var OdConfig = /** @class */ (function () {
    function OdConfig(fileUrl, downloadFileUrl) {
        this._fileUrl = fileUrl;
        this._downloadFileUrl = downloadFileUrl;
    }
    Object.defineProperty(OdConfig.prototype, "fileUrl", {
        get: function () {
            return this._fileUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "downloadFileUrl", {
        get: function () {
            return this._downloadFileUrl;
        },
        enumerable: true,
        configurable: true
    });
    OdConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    OdConfig.ctorParameters = function () { return [
        null,
        null,
    ]; };
    return OdConfig;
}());
export { OdConfig };
//# sourceMappingURL=od-config.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/od-config.js
// module id = 432
// module chunks = 14